module.exports = __webpack_public_path__ + "static/people-inset-photo-39486f359349c588ec50ee9f0a8fcf36.jpg";